import { asyncToGenerator as _asyncToGenerator, objectSpread2 as _objectSpread2 } from "../../_virtual/_rollupPluginBabelHelpers.js";
import { CachePolicies, useFetch as useFetch$1 } from 'use-http';
import { deepMapKeysToCamelCase } from '@appfolio/js-data-mapper';
import parseCsrf from "./parseCsrf.js";
import useDocumentsAppConfigs from "../useDocumentsAppConfigs.js";
/**
 * This provides sensible set of default option for useFetch, but
 * can be overriden by passing an object of type IncomingOtions.
 *
 * Official docs: https://use-http.com/#/?id=options
 */

var defaultOptions = function defaultOptions() {
  return {
    cachePolicy: CachePolicies.NO_CACHE,
    headers: {
      'Content-Type': 'application/vnd.api+json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    interceptors: {
      response: function () {
        var _response2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(_ref) {
          var _response;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _response = _ref.response;

                  if (_response.data) {
                    _response.data = deepMapKeysToCamelCase(_response.data);
                  }

                  return _context.abrupt("return", _response);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function response(_x) {
          return _response2.apply(this, arguments);
        }

        return response;
      }()
    }
  };
};

var useFetch = function useFetch(options) {
  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      apiPrefix = _useDocumentsAppConfi.apiPrefix;

  var defaultOpts = defaultOptions();
  var csrf = parseCsrf();

  if (csrf && defaultOpts.headers) {
    defaultOpts.headers['X-CSRF-TOKEN'] = csrf;
  }

  return useFetch$1(apiPrefix, _objectSpread2(_objectSpread2({}, defaultOpts), options));
};

export default useFetch;
export { defaultOptions };